import { createContext } from 'react';

export const chatContext = createContext({});

export default chatContext;
